export const CANDIDATES_TAGS = {
  list_Of_Candidates: 'list_Of_Candidates',
  list_Of_Candidates_two: 'list_Of_Candidates_two',
  get_candidates: 'get_candidates',
  get_skills_categories: 'get_skills_categories',
}
